<template>
  <tr id="mycardrow" style="padding: 0px;">
    <td style="text-align: center;padding: 0px;"> {{ myindex + 1 }}</td>

    <td style="padding: 0px;width: 60px;">
      <input ref="el_fabcode" type="number" class="form-control" v-model="row.roll_id" @keyup.enter="loadRoll(row.roll_id)"/>
    </td>
    <td style="padding: 0px;">
      <button class="btn btn-outline-success" @click="loadRoll(row.roll_id)" tabindex="-1">Find</button>
    </td>

    <td style="padding-right: 5px;text-align: right;width: 100px;">
      {{ row.qty | numberFormat }}
    </td>

    <td style="padding-right: 5px;text-align: right;width: 100px;">
      {{ row.weight | weightFormat }}
    </td>

    <td style="padding: 0px;">
      {{ row.quality.name }}
    </td>
    <td style="padding: 0px;">
      {{ row.color.name }}
    </td>


    <td style="padding: 0px;text-align: right">
      <button name="btnRemoveRow" type="button"
              class="btn border-warning text-warning-600 btn-flat btn-icon btn-rounded legitRipple btnRemoveRow"
              @click="removeRow(index)" tabindex="-1"><i class="icon-eraser"></i></button>
    </td>

  </tr>
</template>

<script>
import moment from 'moment-timezone'
import { userService } from '@/store/auth-header.js'
import Alert from 'tabulator-tables/src/js/core/tools/Alert'

export default {
  name: 'BaleDetailRow',
  props: {
    myrow: {
      type: Object,
      default: () => JSON.parse('{"idx":0,"id":0,"master_id":0,"itemtype":0,"roll_id":0,"item_id":0,"quality_id":0,"color_id":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""},"size":"","qty":0,"weight":0,"roll":{"id":0,"item":{"id":0,"name":""},"item_id":0,"quality_id":0,"color_id":0}}')
    },
    myindex: {
      type: Number,
      default: () => 0
    },
    myprocess: {
      type: Number,
      default: () => 0
    }
  },
  beforeMount () {
    this.row = this.myrow
    this.index = this.myindex
    this.row.idx = this.myindex
  },
  data () {
    return {
      index: 0,
      row: JSON.parse('{"idx":0,"id":0,"master_id":0,"itemtype":0,"roll_id":0,"item_id":0,"quality_id":0,"color_id":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""},"size":"","qty":0,"weight":0,"roll":{"id":0,"item":{"id":0,"name":""},"item_id":0,"quality_id":0,"color_id":0}}')
    }
  },
  filters: {
    weightFormat (val) {
      return val.toFixed(3)
    },
    numberFormat (val) {
      return val.toFixed(2)
    }
  },
  methods: {
    removeRow () {
      this.$emit('onRemoveRow', Math.abs(this.myindex));
    },
    loadRoll (no) {
      const self = this;
      let rollno = 0;
      try {
        try {
          rollno = parseInt(no)

          if (isNaN(rollno)) {
            rollno = 0
          }

        } catch (e) {
          rollno = 0
        }

        if (rollno < 1) {
          return
        }

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        $('#mycard').block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        })

        self.$data.row.idx = self.myindex;
        //`${process.env.VUE_APP_ROOT_API}api/roll/rollno/${rollno}`

        fetch(`${process.env.VUE_APP_ROOT_API}api/roll/${rollno}`, requestOptions).then(userService.handleResponse).then(function (resp) {
          $('#mycard').unblock()
          if (resp.ok) {

            if (!_.isNull(resp.data)) {

              self.$data.row.roll = resp.data;
              self.$data.row.roll.item_id = resp.data.item_id;
              self.$data.row.quality_id = resp.data.quality.id;
              self.$data.row.color_id = resp.data.color.id;
              self.$data.row.quality = resp.data.quality;
              self.$data.row.color = resp.data.color;
              self.$data.row.qty = resp.data.qty;
              self.$data.row.weight = resp.data.weight;
              self.showmsg(1);
            }
          } else {
            swal({ title: 'Oops!', text: resp.msg, type: 'error', timer: 3000 });
          }
        }).catch(function (err) {
          swal({ title: 'Oh noes!', text: err.toString(), type: 'error', timer: 3000 });
        }).finally(function () {
          $('#mycard').unblock();
        });
      }catch (e) {
        alert(e);
      }
    },
    showmsg (colIndex) {
      const self = this

      try {

        switch (colIndex) {
          case 1:
            // this.row.fabric.id
            this.$emit('onrow_change', this.index, colIndex, this.row)
            break
          case 3:
            this.$emit('onrow_change', this.index, colIndex, parseFloat(this.row.qty))
            break
        }
      } catch (e) {
        alert(e)
      }
    },
    validateQualityColor (fab) {

      const self = this
      let result = false
      try {
        //self.row.quality
        //self.row.color

        // alert("Quality : " + self.$props.parentvoucher.quality.id );
        // alert("Color : " + self.$props.parentvoucher.color.id );
        // alert(self.$props.parentvoucher.quality.id + " = " + fab.quality.id);
        /*
        if(self.$props.parentvoucher.quality.id !== fab.quality.id){
          alert("Invalid Quality");
          self.$refs.el_fabcode.focus();
        }else if(self.$props.parentvoucher.color.id !== fab.color.id){
          alert("Invalid Color");
          self.$refs.el_fabcode.focus();
        }else if(self.$props.parentvoucher.quality.id === fab.quality.id && self.$props.parentvoucher.color.id === fab.color.id){
          result = true;
        }
         */

        result = true

      } catch (e) {
        alert(e)
      }

      return result
    },
  }
}
</script>

<style scoped>
input:focus {
  background: #feff00;

}

textarea:focus {
  background: #feff00;

}

select:focus {
  background: #feff00;
}

button:focus {
  background: #feff00;
  color: #0a0a0a !important;
}
</style>
